const SvgHardware2 = (props) => (
  <>
    <path d="M0 0h96v24H0zM0 32h96v24H0zM0 64h96v24H0z" fill={props.p40} />
  </>
);

export default SvgHardware2;
